const Footer = () => {
  return (
    <footer className="footer">
      <p>&copy; 2025 Product Comparison App. All rights reserved.</p>
    </footer>
  );
}

export default Footer;